import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { validate } from 'email-validator';
import { setDeliveryOptionButtonSelected, updateDeliveryIsSelected, validateCheckout } from '../functions';

const EditEmails = props => {
	const [ editedEmail, setEditedEmail ] = useState( {} );
	const [ editedIndex, setEditedIndex ] = useState( null );
	const [ state, dispatch, notify ] = useContext( GlobalContext );
	const { emails, upload } = state;
	const [ isEmailEmpty, setIsEmailEmpty ] = useState( true );

	useEffect( function() {
		if ( emails.length > props.quantity ) {
			notify( `Öka artikelantalet för att kunna lägga till fler e-postmeddelanden än ${ props.quantity }.` );
			dispatch( {
				type: 'SET_EMAILS',
				payload: emails.slice( 0, props.quantity ),
			} );
		}
	}, [] );

	const onEmailChange = e => {
		const email = { ...editedEmail };
		email[ e.target.name ] = e.target.value;
		setEditedEmail( email );
		if ( email.email ) {
			setIsEmailEmpty( true );
		}
	};

	const onAddEmailClick = e => {
		e.preventDefault();

		if ( ! editedEmail.email || ! validate( editedEmail.email ) ) {
			setIsEmailEmpty( false );
			return;
		}

		if ( null !== editedIndex ) {
			const editedEmails = [ ...emails ];
			editedEmails[ editedIndex ] = editedEmail;
			dispatch( {
				type: 'SET_EMAILS',
				payload: [ ...editedEmails ],
			} );
		} else {
			if ( emails.length >= props.quantity ) {
				notify( `Öka artikelantalet för att kunna lägga till fler e-postmeddelanden än ${ props.quantity }.` );
				return;
			}

			dispatch( {
				type: 'SET_EMAILS',
				payload: [ ...emails, { ...editedEmail } ],
			} );
		}

		setEditedEmail( {} );
		setEditedIndex( null );
		setIsEmailEmpty( true );

		let i = 0;
		const scroll = setInterval( () => {
			i += 0.5;
			document.getElementsByClassName( 'emails' )[ 0 ].scrollTop += i * 50;
			if ( emails.length < i ) {
				clearInterval( scroll );
			}
		}, 100 );
	};

	const onRemoveClick = e => {
		e.preventDefault();
		const editedEmails = emails.filter( ( item, i ) => i !== editedIndex );
		dispatch( {
			type: 'SET_EMAILS',
			payload: [ ...editedEmails ],
		} );
		setEditedIndex( null );
		setEditedEmail( {} );
	};

	return (
		<div className="digital-code-edit-emails">
			<h1>Lägg till ny mottagare</h1>
			<p>Fyll i namn och e-postadresser till mottagare av registreringskoder. Eventuellt ej använda koder får du levererade i bekräftelsemejlet.</p>

			<div className="emails">
				{ emails.map( ( item, i ) =>
					<div key={ i }>
						<p className="email-list-row">{ i + 1 } - { item.firstName } { item.lastName } { '<' }{ item.email }{ '>' } <a onClick={ e => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
							e.preventDefault();
							setEditedEmail( item );
							setEditedIndex( i );
						} }>Ändra</a></p>
					</div>
				) }
			</div>

			<div className="email-row">
				<div>
					<input
						type="text"
						name="firstName"
						placeholder="Förnamn"
						value={ editedEmail.firstName || '' }
						onChange={ onEmailChange }
					/>
				</div>
				<div>
					<input
						type="text"
						name="lastName"
						placeholder="Efternamn"
						value={ editedEmail.lastName || '' }
						onChange={ onEmailChange }
					/>
				</div>
				<div className={ ( isEmailEmpty && ( ! editedEmail.email || validate( editedEmail.email ) ) ) ? 'emailrow valid' : 'emailrow unvalid' }>
					<input
						type="email"
						name="email"
						placeholder="E-post *"
						value={ editedEmail.email || '' }
						onChange={ onEmailChange }
					/>
				</div>
			</div>

			<button className="button btn-forthary" onClick={ onAddEmailClick }>{ null !== editedIndex ? 'Uppdatera' : 'Lägg till mottagare' }</button>

			{ ( null !== editedIndex ) &&
				<button className="btn-remove" onClick={ onRemoveClick }>Tabort</button>
			}

			<nav className="group-right">
				<a className="button btn-fifthary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					notify( null );
					dispatch( {
						type: 'SET_STEP',
						payload: upload ? 'uploadExcel' : 'emails',
					} );
				} }>Ångra</a>

				<a className={ 0 >= emails.length ? 'button btn-secondary disabled' : 'button btn-secondary' } onClick={ e => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					e.preventDefault();

					if ( 0 >= emails.length ) {
						return;
					}

					if ( emails.find( item => ! item.email ) ) {
						notify( 'Mottagaren saknar uppgifter.' );
						return;
					}

					dispatch( {
						type: 'SET_IS_LOADING',
						payload: true,
					} );
					// eslint-disable-next-line no-undef
					fetch( sisuReact.admin_ajax, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
							'Access-Control-Allow-Origin': '*',
						},
						credentials: 'same-origin',
						body: new URLSearchParams( {
							action: 'digital_code_save_line_meta',
							// eslint-disable-next-line no-undef
							nonce: sisuReact.nonce,
							cartItemKey: props.cartItemKey,
							distributionMethod: 'EMAILLISTA',
							emails: JSON.stringify( emails ),
						} ),
					} ).then( function( response ) {
						return response.json();
					} ).then( function( data ) {
						dispatch( {
							type: 'SET_IS_LOADING',
							payload: false,
						} );
						if ( 'false' === data ) {
							notify( 'Något gick fel. Försök igen.' );
						} else {
							notify( 'Ändring sparad.', 'success' );
							updateDeliveryIsSelected( props.cartItemKey, true );
							validateCheckout();
							dispatch( {
								type: 'SET_IS_SAVED',
								payload: true,
							} );
							dispatch( {
								type: 'SET_SAVED_DISTRIBUTION_METHOD',
								payload: 'EMAILLISTA',
							} );
							setDeliveryOptionButtonSelected( props.cartItemKey );
							setTimeout( () => {
								dispatch( {
									type: 'SET_OVERLAY_VISIBILITY',
									payload: false,
								} );
								notify( null );
								dispatch( {
									type: 'SET_STEP',
									payload: 'savedData',
								} );
							}, 1000 );
						}
					} );
				} }>Spara</a>
			</nav>
		</div>
	);
};

export default EditEmails;
